import type { RouteObject } from "react-router-dom";
import { ClassesPage } from "./ClassesPage";
import { PtPage } from "./PtPage";
import { TemplatePage } from "./TemplatePage";

/** `/classes` (Calendar | Templates), `/classes/templates/:id`, `/classes/pt`. Static `pt` and `templates` outrank nothing else here. */
export const routes: RouteObject[] = [
  { path: "classes", element: <ClassesPage /> },
  { path: "classes/pt", element: <PtPage /> },
  { path: "classes/templates/:id", element: <TemplatePage /> },
];
